/* ------------------------------------------------------------------------- */
/*  Accordion element
/* ------------------------------------------------------------------------- */

import DelegateListener from './delegate-listener';
import { slideDown, slideUp } from './slide';

class Accordion {

  constructor(accordionElement, params = {}) {
    if (!accordionElement) {
      return;
    }

    this.buttonClass = typeof params.buttonClass !== 'undefined' && params.buttonClass ? params.buttonClass : 'js-accordion-heading';
    this.contentClass = typeof params.contentClass !== 'undefined' && params.contentClass ? params.contentClass : 'js-accordion-content';
    this.itemClass = typeof params.itemClass !== 'undefined' && params.itemClass ? params.itemClass : 'js-accordion-item';

    const openMultiple = accordionElement.getAttribute('data-open-multiple');
    this.openMultiple = openMultiple && openMultiple === 'true' ? true : false;

    this.accordion = accordionElement;
    this.contentItems = accordionElement.getElementsByClassName(this.contentClass);

    const _context = this;

    DelegateListener('click', '.'+this.buttonClass, function(event) {
      if (!this.disabled) {
        event.preventDefault();
        _context.accordionToggle(event, this);
      }
    }, this.accordion);
  }

  scrollToView(elem) {
    // Make sure the element is visible in viewport
    const rect = elem.getBoundingClientRect();
    const isInViewPort = (
      rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );

    if (!isInViewPort) {
      elem.scrollIntoView({ behavior: 'smooth' });
    }
  }

  showItem(item, button) {
    button.classList.add('is-open');

    slideDown(item, 400, function() {
      item.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      item.setAttribute('aria-hidden', 'false');
    });
  }

  hideItem(item, button, slideTime = 400) {
    button.classList.remove('is-open');

    slideUp(item, slideTime, function() {
      item.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      item.setAttribute('aria-hidden', 'true');
    });
  }

  accordionToggle(event, button) {
    const accordionItem = button.closest('.'+this.itemClass);
    const accordionContent = accordionItem.getElementsByClassName(this.contentClass);
    if (accordionContent.length) {
      const isContentHidden = accordionContent[0].getAttribute('aria-hidden');
      if (!isContentHidden || isContentHidden === 'true') {

        if (!this.openMultiple) {
          // Hide others
          this.hideOthers(accordionContent[0], button);
        }

        // show
        this.showItem(accordionContent[0], button);
      } else {
        // Hide
        this.hideItem(accordionContent[0], button);
      }
    }
  }

  hideOthers(elem, elemButton) {
    for (let i=0;i<this.contentItems.length;i++) {
      const attrHidden = this.contentItems[i].getAttribute('aria-hidden');
      if (this.contentItems[i] !== elem && (attrHidden && attrHidden !== 'true')) {
        const accordionItem = this.contentItems[i].closest('.'+this.itemClass);
        const button = accordionItem.getElementsByClassName(this.buttonClass);

        this.hideItem(this.contentItems[i], button[0], 200);
        setTimeout(() => {
          this.scrollToView(elemButton);
        }, 201);
      }
    }
  }
}

export { Accordion };
